import React, { useState, useEffect } from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import { getWebsiteSettings } from "../../services/websitesetting";

const Website = () => {
  const [subdomain, setSubdomain] = useState("");
  const location = useLocation();

  useEffect(() => {
    const fetchSubdomain = async () => {
      try {
        const data = await getWebsiteSettings();
        if (data?.company_subdomain) {
          setSubdomain(data.company_subdomain);
        }
      } catch (err) {
        console.error("Failed to fetch subdomain in Website layout:", err);
      }
    };
    fetchSubdomain();
  }, []);

  if (location.pathname === "/website" || location.pathname === "/website/") {
    return <Navigate to="/website/templatesection" replace />;
  }

  return (
    <div className="overflow-x-hidden">
      <div className="space-y-6">
        {/* Content Area - Render nested routes */}
        <div className="px-2 md:px-3">
          <Outlet context={{ subdomain }} />
        </div>
      </div>
    </div>
  );
};

export default Website;
